import { Component } from "@angular/core";
import { Router } from "@angular/router";
import {ReturnStoreService} from "../../../return/return-store.service";

@Component({
    selector: 'app-nav-return',
    templateUrl: './nav-return.component.html',
    styleUrls: ['./nav-return.component.scss']
})
export class NavReturnComponent {
    constructor(
        private router: Router,
        private returnStore: ReturnStoreService
    ) {}

    goToHome() {
        this.returnStore.setItem(undefined);
        this.router.navigate(['/home']);
    }
}
